<template>
    <section>
        <div v-if="!disableSwapButton" class="swap-container">
            <div class="swap-button">
                <a data-qa="swap-contact" @click="swapContactRecordPage('TOGGLE')">
                    <ds-chip with-interaction>
                        <span>Switch to old contact record</span>

                        <ds-icon
                            slot="leading"
                            name="replace"
                        />
                    </ds-chip>
                </a>
            </div>
        </div>
        <div>
            <ds-confirm-dialog
                :is-open="isToggleConfirmModalOpen"
                title="Save changes?"
                message="Do you want to save your changes before leaving this page?"
                show-close
                confirm-label="Save changes"
                cancel-button-class="cancel"
                cancel-label="Discard changes"
                size="sm"
                @cancel="confirmModalCancel"
                @confirm="confirmModalSave"
            />
        </div>

        <ds-focus-on-keyboard-only />
    </section>
</template>

<script>
import axios from 'axios';
import amplitude from '@/components/util/analytics/amplitude';

export default {
    props: {
        contactId: [String, Number],
        userId: [String, Number],
        isAmplitudeEnabled: [Boolean],
    },
    data() {
        return {
            swap: 'false',
            isContactInfoChanged: false,
            isContactCustomFieldChanged: false,
            buttonName: '',
            disableSwapButton: false,
            isToggleConfirmModalOpen: false,
        };
    },

    mounted() {
        this.$root.$on('CONTACT_TOGGLE', (isToggle) => {
            if (isToggle) {
                this.swaps();
            }
        });

        this.$root.$on('IS_CONTACT_INFO_CHANGED', (isContactInfoChanged) => {
            this.isContactInfoChanged = isContactInfoChanged;
        });

        this.$root.$on('IS_CONTACT_CUSTOMFIELD_CHANGED', (isContactCustomFieldChanged) => {
            this.isContactCustomFieldChanged = isContactCustomFieldChanged;
        });

        this.$root.$on('OPEN_CONFIRM_MODAL_BACK_BUTTON', (actionItem) => {
            this.buttonName = actionItem;
            this.swapContactRecordPage(this.buttonName);
        });

        this.$root.$on('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', this.disableSwapInCustomizedContactRecord);
    },

    beforeDestroy() {
        this.$root.$off('CONTACT_TOGGLE');
        this.$root.$off('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', this.disableSwapInCustomizedContactRecord);
    },

    methods: {
        disableSwapInCustomizedContactRecord(actionItem) {
            this.disableSwapButton = actionItem;
        },

        swapContactRecordPage(actionItem) {
            this.buttonName = actionItem;

            if (this.isContactInfoChanged || this.isContactCustomFieldChanged) {
                this.openToggleConfirmModal();
            } else {
                this.pageRedirect(this.buttonName);
            }
        },

        async swaps() {
            try {
                if (this.isAmplitudeEnabled) {
                    amplitude.infusionsoft.track(amplitude.infusionsoft.events.TOGGLED_CONTACT_RECORD, {
                        'Event Source': 'toggled contact record layout : NewToOld',
                    });
                }

                await axios.put(`/app/contact/saveAppSetting?userId=${this.userId}&swap=${this.swap}`);

                window.location = `/Contact/manageContact.jsp?view=edit&ID=${this.contactId}`;
            } catch (e) {
                this.$error({ message: 'Something went wrong while toggling.' });
            }
        },

        openToggleConfirmModal() {
            this.isToggleConfirmModalOpen = true;
        },

        closeToggleConfirmModal() {
            this.isToggleConfirmModalOpen = false;
        },

        pageRedirect(actionItem) {
            if (actionItem === 'TOGGLE') {
                this.$root.$emit('CONTACT_TOGGLE', true);
            }

            if (actionItem === 'CLOSE_BUTTON') {
                this.$root.$emit('BACK_BUTTON', true);
            }
        },

        confirmModalSave() {
            this.$root.$emit('OPEN_CONFIRM_MODAL', this.buttonName);
            this.closeToggleConfirmModal();
        },

        confirmModalCancel() {
            this.pageRedirect(this.buttonName);
            this.closeToggleConfirmModal();
        },

    },
};
</script>
